import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useParams } from 'react-router-dom';
import HomePage from './components/HomePage';
import ClinicalWorkflow from './components/ClinicalWorkflow';
import EvaluationComplete from './components/EvaluationComplete';
import AtlasShell from './components/AtlasShell';
import OfflineBanner from './components/OfflineBanner';

const HomePageRoute: React.FC = () => {
  const navigate = useNavigate();
  return (
    <HomePage
      onStartEvaluation={() => navigate('/clinical')}
      onOpenAtlas={() => navigate('/atlas')}
      onContinueDraft={(draftId) => navigate('/clinical', { state: { restoreDraftId: draftId } })}
    />
  );
};

const AtlasRoute: React.FC = () => {
  const { section, subsection } = useParams();
  return <AtlasShell section={section} subsection={subsection} />;
};

const App: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-900 text-gray-100">
      <OfflineBanner />
      <Router>
        <Routes>
          <Route path="/evaluation-complete" element={<EvaluationComplete />} />
          <Route path="/file-upload" element={<Navigate to="/clinical" replace />} />
          <Route path="/upload" element={<Navigate to="/clinical" replace />} />
          <Route path="/clinical-emg" element={<Navigate to="/clinical" replace />} />
          <Route path="/clinical" element={<ClinicalWorkflow />} />
          <Route path="/atlas/:section/:subsection" element={<AtlasRoute />} />
          <Route path="/atlas/:section" element={<AtlasRoute />} />
          <Route path="/atlas" element={<AtlasRoute />} />
          <Route path="/" element={<HomePageRoute />} />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
